import { UtilConfigAnalytics } from './../../../utils/configuracoes/util-config-analytics';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'src/app/analytics/google-analytics.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-conheca-seus-direitos',
  templateUrl: './conheca-seus-direitos.component.html',
  styleUrls: ['./conheca-seus-direitos.component.scss'],
})
export class ConhecaSeusDireitosComponent {
  cardList: Array<any>;

  lgpdConhecaSeusDireitos: string = 'lgpd-conheca-seus-direitos';
  conhecaSeusDireitos: string = 'conheca-seus-direitos';
  acesseSeusDados: string = 'acesse-seus-dados';

  public loadModalVipPepComponent: boolean = false;

  constructor(
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {
    this.googleAnalyticsService.pushTag(
      UtilConfigAnalytics.ConfigAnalytics(
        'page_view',
        null,
        null,
        'deslogado',
        'relatorio-sintetico',
        'Serasa Institucional - LGPD - Conheca Seus Direitos',
        null,
        this.lgpdConhecaSeusDireitos
      )
    );
    this.googleAnalyticsService.pushTag(
      UtilConfigAnalytics.ConfigAnalytics(
        'page_view_ga4',
        null,
        null,
        'deslogado',
        'relatorio-sintetico',
        'Serasa Institucional - LGPD - Conheca Seus Direitos',
        null,
        this.lgpdConhecaSeusDireitos
      )
    );

    this.googleAnalyticsService
      .pushTag(
        UtilConfigAnalytics.ConfigAnalytics(
          'entrar-tela',
          null,
          null,
          'deslogado',
          this.conhecaSeusDireitos,
          null,
          null,
          this.lgpdConhecaSeusDireitos
        )
      )
      .then((response) => {})
      .catch((e) => {});
    this.googleAnalyticsService
      .pushTag(
        UtilConfigAnalytics.ConfigAnalytics(
          'entrar-tela-ga4',
          null,
          null,
          'deslogado',
          this.conhecaSeusDireitos,
          null,
          this.conhecaSeusDireitos,
          this.lgpdConhecaSeusDireitos
        )
      )
      .then((response) => {})
      .catch((e) => {});

    this.cardList = [
      {
        titulo: 'Direito à confirmação',
        descricao:
          'Você pode pedir à Serasa Experian para confirmar se trata dados sobre você.',
      },
      {
        titulo: 'Direito de acesso',
        descricao:
          'Você pode solicitar acesso aos dados que a Serasa Experian trata sobre você.',
        link: '/relatorio-sintetico',
      },
      {
        titulo: 'Direito de correção',
        descricao:
          'Você pode solicitar a correção de seus dados pessoais que sejam tratados pela Serasa Experian e eventualmente estejam incompletos, inexatos ou desatualizados*.',
        link: '/direitos-de-correcao',
      },
      {
        titulo: 'Direito de anonimização, bloqueio ou eliminação de dados',
        descricao:
          'Você pode solicitar a anonimização, o bloqueio ou a eliminação de dados pessoais sobre você que sejam desnecessários, excessivos ou tratados em desconformidade com a LGPD*.',
      },
      {
        titulo: 'Direito de eliminação de dados',
        descricao:
          'Você pode solicitar a eliminação dos dados quando cabível.',
      },
      {
        titulo: 'Direito de opt-out',
        descricao:
          'Você pode solicitar a interrupção ou a retomada do tratamento dos seus dados pessoais para a finalidade de direcionamento de ofertas*.',
        link: '/gerenciar-preferencias',
      },
      {
        titulo: 'Revogação de consentimento',
        descricao:
          'Você pode revogar seu consentimento fornecido quando o tratamento de dados pessoais estiver embasado nessa hipótese legal.',
      },
      {
        titulo: 'Direito de portabilidade',
        descricao:
          'Você pode solicitar a portabilidade dos dados a outro fornecedor de serviço ou produto, de acordo com a regulamentação da ANPD.',
      },
      {
        titulo: 'Direito à informação sobre compartilhamento',
        descricao:
          'Você pode solicitar mais informações sobre com quais entidades públicas e privadas seus dados podem ser compartilhados.',
      },
      {
        titulo: 'Direito à informação sobre não fornecimento do consentimento',
        descricao:
          'Você pode solicitar mais informações sobre quais as consequências do não fornecimento do consentimento.',
      },
    ];
  }
  ngOnInit(): void {}

  irParaRelatorio() {
    this.googleAnalyticsService
      .pushTag(
        UtilConfigAnalytics.ConfigAnalytics(
          'select_content',
          null,
          'serasa-institucional_web_botao_meio_1',
          'deslogado',
          this.acesseSeusDados,
          null,
          null,
          this.lgpdConhecaSeusDireitos,
          'clique-botao'
        )
      )
      .then((response) => {})
      .catch((e) => {});
    this.googleAnalyticsService
      .pushTag(
        UtilConfigAnalytics.ConfigAnalytics(
          'select_content_ga4',
          null,
          'serasa-institucional_web_botao_meio_1',
          'deslogado',
          this.acesseSeusDados,
          null,
          this.acesseSeusDados,
          this.lgpdConhecaSeusDireitos,
          null,
          'botao'
        )
      )
      .then((response) => {})
      .catch((e) => {});

    if (sessionStorage.getItem('accessTokenJWT')) {
      this.router.navigate(['/relatorio-sintetico']);
    } else {
      window.location.href =
        environment.urlPortal +
        '/entrar?redirectUrl=' +
        environment.urlRedirecionamentoRelatorioSintetico;
    }
  }

  irParaHistSolicitacoes() {
    this.router.navigate(['/historico-solicitacoes']);
  }
}
